"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOutput = getOutput;

var _tone = require("tone");

var _tone2 = _interopRequireDefault(_tone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var output = null; /**
                    * Common output stage
                    * @module lib/output.js;
                    */

function getOutput() {
  if (!output) output = makeOutput();
  return output;
}

function makeOutput() {
  var compressor = new _tone2.default.Compressor(-30, 3);
  var gain = new _tone2.default.Gain(0.3);
  compressor.connect(gain);
  gain.toMaster();

  return compressor;
}


//////////////////
// WEBPACK FOOTER
// ./client/lib/output.js
// module id = 265
// module chunks = 0